import { Injectable } from '@angular/core';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { Quote } from '@models/Quote';

@Injectable({
	providedIn: 'root',
})
export class SessionService {
	constructor(private readonly session: QuoteSessionQuery) {}
	public getProjectedRevenue(): Quote {
		return this.session.getValue().quoteDetails;
	}

	/**
	 * Returns the number of pets in current quote.
	 *
	 * @returns The number of pets in the quote.
	 */
	public getPetCount(): number {
		return this.session.getValue().pets.length;
	}

	/**
	 * Returns the rating state of a customer, or an empty string if it is
	 * not available.
	 *
	 * @returns rating state or an empty string if it is undefined.
	 */
	public getRatingState(): string {
		return this.session.getValue().contact.ratingState || '';
	}

	/**
	 * Returns the quote id value from the session object.
	 *
	 * @returns quote id value
	 */
	public getQuoteId(): string {
		return this.session.getValue().id;
	}

	/**
	 * Checks if the phoneNumber of the contact object in
	 * session storage is pre-populated.
	 *
	 * @returns true if phoneNumber is pre-populated, false otherwise.
	 */
	public isPhoneNumberPopulated(): boolean {
		return !!this.session.getValue().contact.phoneNumber;
	}

	/**
	 * Checks if the emailAddress of the contact object in
	 * session storage is pre-populated
	 *
	 * @returns true if emailAddress is pre-populated, false otherwise.
	 */
	public isEmailAddressPopulated(): boolean {
		return !!this.session.getValue().contact.emailAddress;
	}
}
